import React, {useEffect, useState} from "react";
import "./HomePage.css";
import Logo from "../assets/logo/logo.png";
import Banner from "../assets/logo/1.jpg";
import Popup from "./Popup/Popup";
import { useParams, useNavigate } from "react-router-dom";
import BannerImage from "../assets/logo/banner.jpg";


export default function Player() {
    const { id } = useParams();
    const [redirectUrl, setRedirectUrl] = useState("");
    const [show, setShow] = useState(false);
    const [player, setPlayer] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const ref = document.referrer;
        if (ref.includes("facebook.com")) {
            console.log("User came from Facebook");
            setRedirectUrl("https://play.google.com/store/apps/details?id=com.jalsachi.boyversion&referrer=" + encodeURIComponent("utm_source=" + ref + "&utm_campaign=ig4a&utm_content=marketingUser"))
        } else if (ref.includes("instagram.com")) {
            console.log("User came from Instagram");
            setRedirectUrl("https://play.google.com/store/apps/details?id=com.jalsachi.boyversion&referrer=" + encodeURIComponent("utm_source=" + ref + "&utm_campaign=ig4a&utm_content=marketingUser"))
        } else {
            setRedirectUrl("https://play.google.com/store/apps/details?id=com.jalsachi.boyversion&referrer=" + encodeURIComponent("utm_source=" + ref + "&utm_campaign=ig4a&utm_content=marketingUser"))
            console.log("Direct traffic or unknown source");
        }

        setTimeout(() => {
            setShow(true);
        }, 5000);

        setInterval(() => {
            setShow(true);
        }, 60000)
    }, []);

    const shuffleArray = (array) => {
        const shuffledArr = [...array]; // Create a copy to avoid mutation
        for (let i = shuffledArr.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffledArr[i], shuffledArr[j]] = [shuffledArr[j], shuffledArr[i]]; // Swap elements
        }
        return shuffledArr;
    };

    const moviesArray = [{"name":"Raaz ep 1","image":"https:\/\/www.desiprime.vip\/backend\/images\/admin\/movies\/1767938734-69609aaeb8ba4-1749278670-6843dfce3218c-Raaz%201%20App%20Poster.jpg","pot_image":"https:\/\/www.desiprime.vip\/backend\/images\/admin\/movies\/1767938734-69609aaeb8ba4-1749278670-6843dfce3218c-Raaz%201%20App%20Poster.jpg","video":"https:\/\/vz-bb668ea6-235.b-cdn.net\/f450487c-ceaa-434d-bb51-a7d2a5ad9f10\/1440p\/video.m3u8","id":1},{"name":"Raaz Episode 3","image":"https:\/\/www.desiprime.vip\/backend\/images\/admin\/movies\/1767938677-69609a758f313-1749462214-6846acc63d65a-raaz%203%20App%20Poster%20(1).jpg","pot_image":"https:\/\/www.desiprime.vip\/backend\/images\/admin\/movies\/1767938677-69609a758f313-1749462214-6846acc63d65a-raaz%203%20App%20Poster%20(1).jpg","video":"https:\/\/vz-bb668ea6-235.b-cdn.net\/a0d3821b-f87b-4321-bed2-bf677bd646ac\/1440p\/video.m3u8","id":2},{"name":"Raaz Episode 4","image":"https:\/\/www.desiprime.vip\/backend\/images\/admin\/movies\/1767938653-69609a5d4f643-1749461145-6846a899df439-540x720.jpg","pot_image":"https:\/\/www.desiprime.vip\/backend\/images\/admin\/movies\/1767938653-69609a5d4f643-1749461145-6846a899df439-540x720.jpg","video":"https:\/\/vz-bb668ea6-235.b-cdn.net\/f1eddf71-0f80-491e-89f7-2c4f566e0ed5\/1440p\/video.m3u8","id":3},{"name":"SitiyaBaaz Ep 1","image":"https:\/\/www.desiprime.vip\/backend\/images\/admin\/movies\/1767938536-696099e89493a-1749553046-68480f9667f1c-Untitled%20design%20(56).jpg","pot_image":"https:\/\/www.desiprime.vip\/backend\/images\/admin\/movies\/1767938536-696099e89493a-1749553046-68480f9667f1c-Untitled%20design%20(56).jpg","video":"https:\/\/pullzoneeurope.b-cdn.net\/AWS\/0\/1710261016704_467887091709845200_video_VOD.mp4","id":4},{"name":"Sitiyabaaz Ep 2","image":"https:\/\/www.desiprime.vip\/backend\/images\/admin\/movies\/1767938491-696099bbb3e06-1749554922-684816ea137c5-Untitled%20design%20(59).jpg","pot_image":"https:\/\/www.desiprime.vip\/backend\/images\/admin\/movies\/1767938491-696099bbb3e06-1749554922-684816ea137c5-Untitled%20design%20(59).jpg","video":"https:\/\/pullzoneeurope.b-cdn.net\/AWS\/0\/1710571425618_274856104977237200_video_VOD.mp4","id":5},{"name":"Sitiyabaaz ep 3","image":"https:\/\/www.desiprime.vip\/backend\/images\/admin\/movies\/1767938466-696099a2e9051-1749558158-6848238eb1f71-3035b212-0555-4ce0-886c-f486dc1d9229.jpg","pot_image":"https:\/\/www.desiprime.vip\/backend\/images\/admin\/movies\/1767938466-696099a2e9051-1749558158-6848238eb1f71-3035b212-0555-4ce0-886c-f486dc1d9229.jpg","video":"https:\/\/pullzoneeurope.b-cdn.net\/AWS\/0\/1710785142016_127336259087679180_video_VOD.mp4","id":6},{"name":"Rangbaaz Episode 01","image":"https:\/\/www.desiprime.vip\/backend\/images\/admin\/movies\/1767938426-6960997a124fe-1749901031-684d5ee729a60-Untitled%20design%20(71).jpg","pot_image":"https:\/\/www.desiprime.vip\/backend\/images\/admin\/movies\/1767938426-6960997a124fe-1749901031-684d5ee729a60-Untitled%20design%20(71).jpg","video":"https:\/\/pullzoneeurope.b-cdn.net\/desiflix\/Rangbaaz%20trailer_Streaming%20now.mp4","id":7},{"name":"Rangbaaz Episode 2","image":"https:\/\/www.desiprime.vip\/backend\/images\/admin\/movies\/1767938355-69609933e5fbb-1749730062-684ac30ef2611-Untitled%20design%20(66).jpg","pot_image":"https:\/\/www.desiprime.vip\/backend\/images\/admin\/movies\/1767938355-69609933e5fbb-1749730062-684ac30ef2611-Untitled%20design%20(66).jpg","video":"https:\/\/pullzoneeurope.b-cdn.net\/desiflix\/Rangbaaz_2%20teaser%20Streaming%20now.mp4","id":8},{"name":"Rangbaaz Episode 03","image":"https:\/\/www.desiprime.vip\/backend\/images\/admin\/movies\/1767938388-696099549c0d0-1749731623-684ac92739727-270x390%201%20(1).jpg","pot_image":"https:\/\/www.desiprime.vip\/backend\/images\/admin\/movies\/1767938388-696099549c0d0-1749731623-684ac92739727-270x390%201%20(1).jpg","video":"https:\/\/pullzoneeurope.b-cdn.net\/desiflix\/Rangbaaz%20trailer_Streaming%20now.mp4","id":9},{"name":"Munni Badnaam Hui Episode 1","image":"https:\/\/www.desiprime.vip\/backend\/images\/admin\/movies\/1767938204-6960989cce01c-1749903226-684d677a37e88-Untitled%20design%20(61).jpg","pot_image":"https:\/\/www.desiprime.vip\/backend\/images\/admin\/movies\/1767938204-6960989cce01c-1749903226-684d677a37e88-Untitled%20design%20(61).jpg","video":"https:\/\/pullzoneeurope.b-cdn.net\/desiflix\/Munni%20badnam%20huai_Streaming%20now%20trailer.mp4","id":10},{"name":"Munni Badnaam Hui Episode 2","image":"https:\/\/www.desiprime.vip\/backend\/images\/admin\/movies\/1767938204-6960989cce01c-1749903226-684d677a37e88-Untitled%20design%20(61).jpg","pot_image":"https:\/\/www.desiprime.vip\/backend\/images\/admin\/movies\/1767938204-6960989cce01c-1749903226-684d677a37e88-Untitled%20design%20(61).jpg","video":"https:\/\/pullzoneeurope.b-cdn.net\/desiflix\/Munnai%20Badnam%20Huai_2_Treailer%20streaming%20now.mp4","id":11},{"name":"Munni Badnaam Hui Episode 3","image":"https:\/\/www.desiprime.vip\/backend\/images\/admin\/movies\/1767938312-6960990839674-1749905413-684d700508046-Untitled%20design%20(64).jpg","pot_image":"https:\/\/www.desiprime.vip\/backend\/images\/admin\/movies\/1767938312-6960990839674-1749905413-684d700508046-Untitled%20design%20(64).jpg","video":"https:\/\/pullzoneeurope.b-cdn.net\/desiflix\/Munnai%20Badnam%20Huai_3%20Trailer%20Straming%20noww.mp4","id":12},{"name":"2 Kaminey 2 Naginey Episode 01","image":"https:\/\/www.desiprime.vip\/backend\/images\/admin\/movies\/1767938154-6960986ae0862-1749907513-684d7839155bc-App-Poster-Desi%20(1).jpg","pot_image":"https:\/\/www.desiprime.vip\/backend\/images\/admin\/movies\/1767938154-6960986ae0862-1749907513-684d7839155bc-App-Poster-Desi%20(1).jpg","video":"https:\/\/pullzoneeurope.b-cdn.net\/desiflix\/2kamine%202%20nagine_%20streaming%20now.mp4","id":13}];
    const movies = shuffleArray(moviesArray);

    useEffect(() => {
        if(id) {
            const movieIndex = movies.findIndex(res => res.id == id);
            if(movieIndex >= 0) {
                setPlayer(movies[movieIndex]);
            }
        }
    }, [id]);

    const openMedia = (id) => {
        navigate("/player/" + id);
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    },[])

    const downloadApp = () => {
        if (window.fbq) {
            window.fbq('track', 'Subscribe', {value: '0.00', currency: 'USD', predicted_ltv: '0.00'});
            //window.fbq('track', 'Subscribe');
        }
        window.open(redirectUrl, '_blank');
    }

    const getVideoExtension = (url) => {
        // Use the URL object to correctly parse the pathname, ignoring query parameters or hashes
        const pathname = new URL(url).pathname;
        // Split the pathname by the dot character
        const parts = pathname.split('.');
        // Get the last part and convert to lowercase for consistency
        const extension = parts.pop().toLowerCase();
        return extension;
    };

    return (
        <div className="page">

            {/* Header */}
            <div className="header">
                <img src={Logo} alt="logo" className="logo-img" onClick={() => navigate("/")} />
                <a onClick={downloadApp} className="down-btn">Download App</a>
            </div>

            {/* Video */}
            {/*{player?.video && getVideoExtension(player?.video) == 'm3u8' ? (
                <video
                    controls
                    playsinline
                    src={`https://chanderi.webverbatim.in/api/hls.php?url=${player?.video}`} className="video-player" autoPlay={true}
                />
            ): (
                <video
                    controls
                    playsinline
                    src={player?.video} className="video-player" autoPlay={true}
                />
            )}*/}
            <video
                controls
                playsinline
                src={player?.video} className="video-player" autoPlay={true}
            />
            {/*<video src={player?.video} controls className="video-player" autoPlay={true} />*/}

            {/* Banner */}
            <a onClick={downloadApp}><img src={Banner} className="banner" alt="" /></a>


            {/* You may like */}
            <h2 className="section-title">You may like</h2>

            <div className="movies-grid">
                {movies.map((m, i) => (
                    <img onClick={() => navigate("/player/" + m.id)} key={i} src={m.pot_image} className="movie-card" onClick={() => openMedia(m.id)} />
                ))}
            </div>

            {/* Install Button bottom fixed */}
            <a onClick={downloadApp} className="install-btn">Install App</a>
            <Popup show={show} onClose={() => setShow(false)}>
                <h2 className={'modal-title'}>Latest Web Series</h2>
                <img src={BannerImage} className={'w-100'}/>
                <p className={'modal-desc'}>Fresh Movies &amp; Webseries Added – Don’t Miss Out!</p>
                <div className={'bottom-div'}>
                    <a onClick={downloadApp} className="btn-download">Install App</a>
                </div>
            </Popup>
        </div>
    );
}
